import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useTemplate = (pageSize, currentPage) => {
    return useQuery(QUERY_KEY.GET_TEMPLATE, () => ApiService.getTemplate(pageSize, currentPage))
}

export default useTemplate